<template>
	<svg
		width="16"
		height="20"
		viewBox="0 0 16 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M14 20H2C1.45 20 0.979333 19.8043 0.588 19.413C0.196 19.021 0 18.55 0 18V2C0 1.45 0.196 0.979 0.588 0.587C0.979333 0.195667 1.45 0 2 0H9.175C9.44167 0 9.696 0.0500001 9.938 0.15C10.1793 0.25 10.3917 0.391667 10.575 0.575L15.425 5.425C15.6083 5.60833 15.75 5.82067 15.85 6.062C15.95 6.304 16 6.55833 16 6.825V18C16 18.55 15.8043 19.021 15.413 19.413C15.021 19.8043 14.55 20 14 20ZM8 15.75C9.3 15.75 10.4167 15.2833 11.35 14.35C12.2833 13.4167 12.75 12.3 12.75 11C12.75 9.7 12.2833 8.58333 11.35 7.65C10.4167 6.71667 9.3 6.25 8 6.25C7.36667 6.25 6.775 6.36667 6.225 6.6C5.675 6.83333 5.18333 7.15 4.75 7.55V6.75C4.75 6.53333 4.67933 6.354 4.538 6.212C4.396 6.07067 4.21667 6 4 6C3.78333 6 3.60433 6.07067 3.463 6.212C3.321 6.354 3.25 6.53333 3.25 6.75V9.25C3.25 9.53333 3.34567 9.77067 3.537 9.962C3.729 10.154 3.96667 10.25 4.25 10.25H6.75C6.96667 10.25 7.146 10.179 7.288 10.037C7.42933 9.89567 7.5 9.71667 7.5 9.5C7.5 9.28333 7.42933 9.104 7.288 8.962C7.146 8.82067 6.96667 8.75 6.75 8.75H5.7C5.98333 8.45 6.325 8.20833 6.725 8.025C7.125 7.84167 7.55 7.75 8 7.75C8.9 7.75 9.66667 8.06667 10.3 8.7C10.9333 9.33333 11.25 10.1 11.25 11C11.25 11.9 10.9333 12.6667 10.3 13.3C9.66667 13.9333 8.9 14.25 8 14.25C7.35 14.25 6.77067 14.0793 6.262 13.738C5.754 13.396 5.35833 12.95 5.075 12.4C5.025 12.2833 4.94167 12.1877 4.825 12.113C4.70833 12.0377 4.58333 12 4.45 12C4.13333 12 3.896 12.1083 3.738 12.325C3.57933 12.5417 3.56667 12.7833 3.7 13.05C4.08333 13.85 4.65833 14.5 5.425 15C6.19167 15.5 7.05 15.75 8 15.75Z"
			fill="black"
		/>
	</svg>
</template>

<script>
export default {
	name: "Restore",
};
</script>
